/**
 * @module app.bdc.reports.bdcScanupCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BDCScanupCtrl($scope, $window, $rootScope, pricesService) {
        var self = {};
        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);

        /**
         * Gate the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get the date installation, only defined when the order has been signed
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        self.filterPriceByContractTypeAndMarketType = function filterPriceByContractTypeAndMarketType(price) {
            if (
                price.type.code === self.order.scanupContractType.code &&
                price.marketType.code === self.order.marketType.code
            ) {
                return true;
            }
        };

        self.scanups = [];
        self.scanupInstallation = self.order.scanupInstallation;
        self.scanupContractType = self.order.scanupContractType;

        /**
         * Init the scanup collection
         */
        function _initScanupList() {
            for (var i = 0; i < self.order.options.length; i++) {
                if (self.order.options[i].optionType.code === 'SCANUP') {
                    self.scanups.push(self.order.options[i]);
                }
            }
        }

        _initScanupList();

        return self;
    }

    BDCScanupCtrl.$inject = ['$scope', '$window', '$rootScope', 'pricesService'];

    angular.module('app.bdc.reports.bdcScanupCtrl', []).controller('BDCScanupCtrl', BDCScanupCtrl);
});
